import React from "react";
import Accordion from "../../atoms/Accordion";
import { formatSpanishDate } from "../../../utils/dateUtils";

const FaqSection = ({ faq, endTime }) => {
  const items = [
    ...faq,
    { q: "¿Hasta cuándo puedo votar?", a: `Hasta el ${formatSpanishDate(endTime)}.` },
  ];

  return (
    <div>
      {items.map((item) => (
        <Accordion key={item.q} title={item.q} variant="plain">
          {item.a}
        </Accordion>
      ))}
    </div>
  );
};

export default FaqSection;
